import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import ApiEndpoint from '../../services/ApiEndpoint';
import {Observable} from 'rxjs';
import {ControlReportTab} from './cr-design/cr-design-intefaces';
import {SseService} from '../../services/sse/sse.service';
import {AlertService} from '../../services/alert/alert.service';
import {map, take} from 'rxjs/operators';
import {ErrorReportComponent} from './cr-issue/error-report/error-report.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TableNames} from './cr-issue/cr-details/cr-details';
import {stringifyTask} from '@angular/compiler-cli/ngcc/src/execution/tasks/utils';
import {formatDate} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ControlReportService {

  constructor(private http: HttpClient,
              private modalService: BsModalService,
              private sse: SseService, private alerts: AlertService,
              public bsModalRef: BsModalRef) {
  }

  mcrTableNames = TableNames;

  designEndpoint: string = `${ApiEndpoint.baseURL}/cr/design/`;
  tableColumnData: { systemTables: any, designTables: any };
  crConf: { name?: string, segment?: string, desc?: string, overallLogic?: string, type?: string, dataProcessMethod?:string } = {};
  dataset: {
    title: 'Foundation Table' | 'Base Table' | 'Annexure Table' | 'Insight' | 'Summary Table',
    tabIdx: number,
    tabs: ControlReportTab[],
    isOpen: boolean
  }[] = [];
  uniqueValues: { name: string, values: string[] }[] = [];

  getTables(id: any) {
    let formData = new FormData();
    formData.append('crId', id);
    return this.http.post(this.designEndpoint + 'tables', formData);
  }

  getTable(id: any) {
    let formData = new FormData();
    formData.append('id', id);
    return this.http.get(this.designEndpoint + `${id}/table`);
  }

  testTable(payload: any) {
    return this.http.post(this.designEndpoint + 'query/build-and-execute', payload);
  }

  checkExpression(payload: any) {
    return this.http.post(this.designEndpoint + 'check/expression', payload, {responseType: 'text'});
  }

  saveTable(payload: any) {
    return this.http.post(this.designEndpoint + 'query/save', payload);
  }

  saveOverallLogic(crId: any, overallLogic: any, dataProcessMethod:string) {
    let formData = new FormData();
    formData.append('crId', crId);
    formData.append('overallLogic', overallLogic || '');
    formData.append('dataProcessMethod', dataProcessMethod || 'daily');
    return this.http.post(this.designEndpoint + 'save/details', formData);

  }

  saveState(crId: string) {
    let saveData = [...this.dataset];
    saveData.forEach(data => {
      data.tabs.forEach(tab => {
        tab.showTables = false;
        tab.systemTables = [];
        tab.designTables = [];
      })
    });
    let formData = new FormData();
    return this.http.post(this.designEndpoint + `state/save/${crId}`, saveData, {responseType: 'text'});
  }

  submitDesign(crId: string) {
    let formData = new FormData();
    formData.append('crId', crId);
    return this.http.post(this.designEndpoint + 'submit', formData, {responseType: 'text'});
  }

  getList(payload: any) {

    return this.http.post(this.designEndpoint + 'list', payload);
  }

  getConfList() {
    return this.http.get(this.designEndpoint + 'conf/list');
  }

  viewCrDesignExecution(id: any, startDate: any, endDate: any, startTime:any, endTime:any) {
    let payload:any = {};
    payload.crId = id;
    startDate && (payload.startDate = formatDate(startDate, 'yyyy-MM-dd', 'en-US'));
    endDate && (payload.endDate = formatDate(endDate, 'yyyy-MM-dd', 'en-US'));
    startTime && (payload.startTime = startTime);
    endTime && (payload.endTime = endTime);
    return this.sse.cloudflareTolerance(this.designEndpoint + 'view', payload, '', true);
  }

  deleteDesignTable(queryId: string) {
    let formData = new FormData();
    queryId && formData.append('id', queryId);

    return this.http.post(this.designEndpoint + 'delete-design-table', formData, {responseType: 'text'});

  }

  spreadDesignTable(tableData: any) {
    this.dataset.forEach(data => {
      data.tabs.forEach(tab => {
        tab.designTables.push({queryId: tableData.queryId, name: tableData.name, source: data.title, isChecked: false})
      })
    })
  }

  getSystemTables() {
    let systemTables = [];
    Object.keys(this.tableColumnData.systemTables).map(table => systemTables.push({name: table, isChecked: false}));
    return systemTables;
  }

  getDesignTables() {
    let designTables = [];
    Object.keys(this.tableColumnData.designTables).map(table => designTables.push({
      queryId: this.tableColumnData.designTables[table].queryId,
      name: table,
      source: this.tableColumnData.designTables[table].source,
      isChecked: false
    }));
    return designTables;
  }

  getPayload(tab: ControlReportTab) {
    return {
      designId: tab.queryId,
      type: tab.type,
      riskType: tab.riskType,
      relationType: tab.relationType,
      name: tab.name,
      crId: tab.crId,
      crLogic: tab.crLogic,
      desc: tab.description,
      dateTable: tab.dateTable,
      dateColumn: tab.dateColumn,
      timeColumn: tab.timeColumn,
      dateQueryId: tab.dateQueryId,
      showOnView: tab.isView,
      primaryTable: tab.primaryTable,
      primaryKey: tab.primaryKey,
      primaryTableQueryId: tab.primaryTableQueryId,
      joins: tab.joinedTables,
      graph: tab.graphInfo ? tab.graphInfo.type : null,
      graphPlots: tab.graphInfo ? tab.graphInfo.plots : null,
      projections: tab.criteriaList
    }
  }

  getDependencies(queryId: string) {
    return this.http.get(this.designEndpoint + `${queryId}/dependencies`);

  }

  loadUniqueValues(param: { pType: string }) {
    return this.http.post(this.designEndpoint + `unique-values`, param);

  }

  getPcrDetailData(payload: any) {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.baseURL}/ps/pcr/data`, payload, '', true)
  }
  cancelPCr(obj): Observable<any>{
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.queryServiceURL}/ps/pcr/cancel`, {},{params: httpParams});
  }

  getCrDetailData(payload: any) {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.baseURL}/cr/information`, payload, '', true)
  }

  getTrpDetailData(payload: any) {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.baseURL}/trp/detail/data`, payload, '', true)
  }

  getCrFilterValues(payload: any) {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/issue/filter/value`, payload)
  }

  downloadCrTable(payload: any) {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/cr/download`, payload)
  }

  downloadTrpTable(payload: any) {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/trp/table/download`, payload)
  }

  downloadPcrTable(payload: any) {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/ps/pcr/data/download`, payload)
  }
  downloadPcrMonitorTable(payload: any) {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/ps/pcr/monitor/list/download`, payload)
  }

  controlReportMonitorList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/monitor/list`, obj);
  }

  controlReportIssueList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/issue/list`, obj);
  }


  TransactionMonitoringControlList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/tmc/list`, obj);
  }

  TransactionMonitoringControlListDownload(obj): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/tmc/list/download`, obj)
  }

  trpList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/list`, obj);
  }

  downloadTrpMonitorList(data): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.queryServiceURL}/trp/download/trp/monitor/list`, data, '', 'blob');
  }

  getAssignedCrList(): Observable<any> {
    return this.fetchCrConfig({param: 'CR Assigned List'});
  }

  getAssignedTMCList(): Observable<any> {
    return this.fetchCrConfig({param:'CR Assigned List',extraParam:'Transaction Monitoring Control'});
  }

  getAssignedRMCRList(): Observable<any> {
    return this.fetchCrConfig({param: 'CR Assigned List', extraParam: 'Risk Mitigation Control Report'});
  }

  getTotalEddRequest(id: string) {
    return this.fetchCrConfig({param: 'EDD Request Sent', pid: id});
  }

  executeCr(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/issue/execute`, obj);
  }


  executeTMC(obj,): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/tmc/issue`, obj,{ responseType: 'text' });
}

  issueTrp(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/issue`, obj);
  }

  getCrReportData(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/report/writing/list`, obj);
  }

  // saveCrReportData(obj, approverData = null): Observable<any> {
  //   if (obj.type == 'Approved From Control Report' || obj.type == 'Approved From Product Control Report' || obj.type == 'Final Submit') {
  //     obj.params = approverData;
  //     return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/report/writing/approver/save`, obj);
  //   }
  //   return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/report/writing/save`, obj);
  // }

  saveCrReportData(obj, approverData = null): Observable<any> {
    let currentRoleIndex = localStorage.getItem('roleIndex');
    obj.existedRoleName = JSON.parse(localStorage.getItem('currentRole'))[currentRoleIndex].roleName;

    if (obj.type == 'Approved From Control Report' || obj.type == 'Approved From Product Control Report' || obj.type == 'Final Submit') {
      obj.params = approverData;
      return this.sse.cloudflareTolerance(`${ApiEndpoint.queryServiceURL}/cr/report/writing/approver/save`, obj,'', true);
    }
    return this.sse.cloudflareTolerance(`${ApiEndpoint.queryServiceURL}/cr/report/writing/save`, obj,'', true);
  }

  saveReportFile(obj) {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/report/writing/attachment/upload`, obj);
  }

  parseRecommendedAccounts(sections: any) {
    let accountData = [];
    let accountNumbers = [];

    try {
      for (let section of sections) {
        if (section.name == 'Recommendation') {
          for (let content of section.content) {
            if (content.type == 'Rec_Table') {
              accountData = content.data && content.data.Account
            }
          }
          break;
        }
      }

      for (let account of accountData) {
        accountNumbers = accountNumbers.concat(account.data)
      }

      return accountNumbers.map(acc => acc.account_number).join(',')
    } catch (e) {
      return ''
    }
  }


  getCRUnassignList(obj: any) {
    return this.http.post(`${ApiEndpoint.baseURL}/control-report/unassign/list`, obj);
  }

  getCRassignList(obj: any) {
    return this.http.post(`${ApiEndpoint.baseURL}/control-report/assign/list`, obj);
  }

  assignCR(obj: any) {
    return this.http.post(`${ApiEndpoint.baseURL}/control-report/assign`, obj);
  }

  fetchCrConfig(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/config/data`, obj);
  }

  fetchTmcList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.baseURL}/tmc/list`, obj);
  }


  addContent(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/report/writing/content/add`, obj, {responseType: 'text'});
  }


  // Helpers For CR Design
  clearCrDesignTab(controlReportTab: ControlReportTab) {
    this.clearCrDesignTabTables(controlReportTab);
    controlReportTab.name = '';
    controlReportTab.description = '';
  }

  clearCrDesignTabTables(controlReportTab: ControlReportTab) {
    this.clearCrDesignTabJoins(controlReportTab);
    controlReportTab.step = 0;
    controlReportTab.systemTables.forEach(i => i.isChecked = false);
    controlReportTab.designTables.forEach(i => i.isChecked = false);
  }

  clearCrDesignTabJoins(tab: ControlReportTab) {
    this.clearCrDesignTabProjections(tab);
    tab.step = 1;
    tab.primaryTable = undefined;
    tab.primaryKey = '';
    tab.primaryTableQueryId = '';
    tab.selectedTables = [];
    tab.joinedTables = [];
    if (tab.relationType == 'UNION') {
      tab.joinedTables = [{}];
    }
  }

  clearCrDesignTabProjections(tab: ControlReportTab) {
    tab.riskType = '';
    tab.dateTable = '';
    tab.dateColumn = '';
    tab.dateQueryId = '';
    tab.isView = true;
    tab.crLogic = '';
    tab.primaryKeyIdx = undefined;
    tab.primaryDateIdx = undefined;
    tab.criteriaList = [{isView: true}]
  }

  raiseEdd(payload: any, executeDate: string) {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/issue/edd/raise?executeDate=${executeDate}`, payload, {responseType: 'text'});
  }

  raiseInv(payload: any) {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/issue/investigation/raise`, payload, {responseType: 'text'});
  }

  cancelCr(crIssueId: string, remark: string) {
    return this.http.post(`${ApiEndpoint.baseURL}/cr/${crIssueId}/cancel`, remark);
  }

  executeRMCR(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/issue/rmcr/execute`, obj);
  }

  productSegmentIssueList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/pcr/issue/list`, obj);
  }

  markedSystemTableList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/mst/list`, obj);
  }

  updateMarkedSystemTable(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/mst/update`, obj);
  }

  changeMSTStatus(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/mst/status/update`, obj);
  }

  addAsJsonReportContent(crId: string, crIssueId: string, tableName: string, data: any, headers: string, keys: string, contentId: any = null, module) {
    this.alerts.loading();
    let obj: any = {};
    obj.crIssueId = crIssueId;
    obj.crId = crId;
    obj.contentName = tableName;
    obj.contentId = contentId;
    obj.contentJson = JSON.stringify(data);
    obj.analysisType = 'Table';
    obj.contentType = 'Table';
    obj.headers = '';
    obj.keys = '';
    obj.module = module;

    this.addContent(obj).subscribe(res => {
      this.alerts.toast('success', tableName + ' added as report content');
      this.alerts.closeAlert()
    }, error => {
      this.alerts.toast('error', tableName + ' failed to add as report content');
      this.alerts.closeAlert()
    })
  }

  getAddedTable(contentId: string): Observable<any> {
    return this.http.get(`${ApiEndpoint.queryServiceURL}/cr/report/writing/get/table/${contentId}`);
  }

  getSchedulerRMCRList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/scheduler-rmcr/list`, obj);
  }

  public downloadMonitorList(data): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.queryServiceURL}/cr/issue/monitor/list/download`, data, '', 'blob');
  }

  public downloadReportRecommendation(data: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/cr/report/writing/recommendation/download/excel`, data, {responseType: 'blob'});
  }

  getApprovalWorkflowInfo(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.baseURL}/query/log/config/item`, obj).pipe(
      map((res: any) => res?.result || [])
    );
  }

  downloadReportFiles(param: any) {
    let httpParams = new HttpParams({fromObject: param});
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.baseURL}/cr/report/writing/download/report/files?`, {}, httpParams.toString(), 'blob')
  }

  mcrFileUpload(data: any) {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/mcr/request/type/data/add`, data);
  }
// used dont delete
  mcrErrorReport(obj): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.baseURL}/mcr/error/data`, {}, {params: httpParams});
  }

  trpErrorReport(obj): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.baseURL}/trp/error/data`, {}, {params: httpParams});
  }
  fcaErrorReport(obj): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/error/data`, {}, {params: httpParams});
  }

  downloadMcrErrorReport(obj: any): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.queryServiceURL}/mcr/error/data/download`, {}, {responseType: 'blob', params: httpParams});
  }

  downloadTrpErrorReport(obj: any): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/error/data/download`, {}, {responseType: 'blob', params: httpParams});
  }
  downloadFcaErrorReport(obj: any): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/error/data/download`, {}, {responseType: 'blob', params: httpParams});
  }
// used dont delete
  executeMcr(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/mcr/issue`, obj);
  }

  executePcr(obj): Observable<any> {
    const httpParams = new HttpParams({fromObject: obj});
    return this.http.post(`${ApiEndpoint.queryServiceURL}/ps/pcr/issue`, {}, {params: httpParams});
  }

  mcrAnnexureUpload(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/mcr/annexure/upload`, obj);
  }

  mcrInsightUpload(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/mcr/insight/upload`, obj);
  }

  trpRiskFileUpload(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/risk/file/upload`, obj,{responseType:'text'});
  }

  trpRiskFileProcess(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.queryServiceURL}/trp/risk/file/process`, obj, '', true);
  }

  checkErrors(uploadRes: any, uniqueId: string, requestType: string, uploadType: string) {

    let failMessage = `There are some ${requestType == 'photo id' ? 'photo ID' : 'account'}(s) that are invalid. Please view the error report to know the details`;

    if (uploadRes?.statusCode == 412 || uploadRes?.statusCode == 204) {
      this.alerts.toast('error', uploadRes?.message);
      return false;
    }

    if (uploadRes?.message == 'Invalid Data Found') {
      // this.alerts.toast('info', `There are some ${requestType}(s) that are invalid. Please view the error report to know the details`);


      this.alerts.openConfirmationModal('Upload Details', failMessage, 'View Error Report ', 'Cancel')
        .pipe(take(1))
        .subscribe((res: boolean) => {


          if (res == true) {
            let initialState = {
              uploadType: uploadType,
              requestType: requestType,
              generatedId: uniqueId,
              tableName: uploadRes?.result?.tableName,
              primaryKey: uploadRes?.result?.primaryKey,
            };
            console.log(initialState)

            this.modalService.show(ErrorReportComponent, {
              initialState,
              backdrop: 'static', keyboard: false,
              class: 'modal-dialog modal-dialog-centered'
            });
            setTimeout(() => {
              this.bsModalRef.hide()
            }, 600);
          }
          return;
        })


      return false;
    }

    return true;
  }


  downloadSample(fileName: string) {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = `/assets/sample/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  getUniqueKey(tableName: string) {
    if (tableName == this.mcrTableNames.mcr_annex_account) {
      return 'Account Number';
    } else if (tableName == this.mcrTableNames.mcr_annex_phId) {
      return 'Photo ID';
    }
    return '_accountNumber';
  }

  getUniqueKeyGeneralRec(isMcr: boolean, recAgainst: string) {
    if (isMcr) {
      if (recAgainst == 'Account') return 'account_number';
      return 'photo_id_number';
    }
    return '_accountNumber';
  }

  pcrCrList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/ps/unused/control-report-list`, obj);
  }

  pcrIssueList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/ps/pcr/issue/list`, obj);
  }

  finalRiskList(pcrIssueId, trpId, riskType): Observable<any> {
    let httpParams = new HttpParams();
    pcrIssueId && (httpParams = httpParams.append('pcrIssueId', pcrIssueId));
    trpId && (httpParams = httpParams.append('trpId', trpId));
    httpParams = httpParams.append('riskType', riskType);

    return this.http.get(`${ApiEndpoint.queryServiceURL}/ps/risk/list`, {params: httpParams});
  }

  // finalRiskAdd(pcrIssueId, trpId,riskType, finalRiskList: any[]): Observable<any> {
  //   let httpParams = new HttpParams();
  //   pcrIssueId && (httpParams = httpParams.append('pcrIssueId', pcrIssueId));
  //   trpId && (httpParams = httpParams.append('trpId', trpId));
  //   httpParams = httpParams.append('riskType', riskType);
  //   return this.http.post(`${ApiEndpoint.queryServiceURL}/ps/risk/add`, finalRiskList, {responseType: 'text',params: httpParams});
  // }

  finalRiskAdd(pcrIssueId, trpId,riskType, finalRiskList: any[]): Observable<any> {
    let param = '';
    pcrIssueId && (param = '?pcrIssueId='+pcrIssueId);
    trpId && (param = '?trpId='+trpId);
    param =param +'&riskType='+riskType;
    // httpParams = httpParams.append('riskType', riskType);
    return this.sse.cloudflareTolerance(`${ApiEndpoint.queryServiceURL}/ps/risk/add`, finalRiskList,param, true);

  }

  resetRisk(trpId): Observable<any> {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/risk/reset?trpId=${trpId}`, {});
  }

  changeTrpStatus(obj): Observable<any> {
    // if(obj && obj?.status='Draft'){
      return this.sse.cloudflareTolerance(`${ApiEndpoint.queryServiceURL}/trp/change/status`, obj,'', true);
    // }else{
    //
    // }
   // return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/change/status`, obj);

  }

  initializeDetails(trpId): Observable<any> {
    return this.http.get(`${ApiEndpoint.queryServiceURL}/trp/details/initialize?trpId=${trpId}`);
  }

  getTrpRemarks(formData: FormData) {
    return this.http.post(`${ApiEndpoint.queryServiceURL}/trp/remarks`, formData);
  }

  concatWithComma(str1, str2) {
    str1 = str1 || '';
    str2 = str2 || '';
    return (str1 && str2) ? `${str1},${str2}` : `${str1}${str2}`;
  }

  addDiscardRecommendation(data: any) {
    const apiUrl = `${ApiEndpoint.queryServiceURL}/cr/issue/recommendation/add/discard`;
    return this.http.post(apiUrl, data);
  }
}
